const roleAccess = {
  1: ['Holidays Config', 'Customers', 'Change owner', 'Account settings', 'Integration', 'Master data'],
  2: ['Holidays Config', 'Customers', 'Account settings'],
  3: ['Holidays Config', 'Account settings'],
  4: [],
  5: [],
  6: [],
  7: []
};


const menu =  [
  // {
  //   key: '/admin/payroll',
  //   icon:'PayslipOutlined',
  //   label: "Payroll"
  // },
  {
    key: '/admin/holiday',
    icon:'CalendarOutlined',
    label: "Holidays Config"
  },
  // {
  //   key: '/admin/announcements',
  //   icon:'AnnouncementsOutlined',
  //   label: "Announcements"
  // },
  // {
  //   key: '/admin/customers',
  //   icon:'ClientsOutlined',
  //   label: "Customers"
  // },
  // {
  //   key: '/admin/policy',
  //   icon:'DocumentsOutlined',
  //   label: "Policy Documents"
  // },
  {
    key:'/admin/changeowner',
    label:'Change owner',
    icon:'UsersOutlined'
  },
  {
    key: '/admin/integration',
    icon:'EpicOutlined',
    label: "Integration"
  },
  {
    key: '/admin/settings',
    icon:'SettingsOutlined',
    label: "Account settings"
  },
  {
    key: '/admin/masterData',
    icon:'AssetsOutlined',
    label: "Master data"
  }
];
  
function getAdminMenuForRoles(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus.add(item));
  });
  return menu.filter(menuItem => accessibleMenus.has(menuItem.label));
}

  
export {
  getAdminMenuForRoles
};
  